import React from 'react'
import { createUseStyles } from 'react-jss'
import COLORS from 'styles/colors'

type Props = {
  title: string
  value: number
  minValue: number
  maxValue: number
  valueLabel?: string
  minLabel?: string
  maxLabel?: string
}

const ROW_WIDTH = 270
const INDICATOR_RADIUS = 10

const ScoreRow = (props: Props) => {
  const classes = useStyles(props)

  const getIndicatorPosition = () => {
    const position = (props.value * ROW_WIDTH) / props.maxValue
    // Calculation so the indicator doesn't overflow the row to the left or right
    if (position < 10) {
      return 5
    }
    if (position > 260) {
      return 250
    }
    return position - INDICATOR_RADIUS
  }

  return (
    <div className={classes.container}>
      <p className={classes.text}>
        {props.title}: <span>{props.valueLabel || props.value}</span>
      </p>

      <div className={classes.scoreRowContainer}>
        <div className={classes.badSection} />
        <div className={classes.midSection} />
        <div className={classes.goodSection} />

        <div className={classes.indicator} style={{ left: getIndicatorPosition() }} />
      </div>
      <div className={classes.minMaxRow}>
        <p className={classes.text}>{props.minLabel || props.minValue}</p>
        <p className={classes.text}>{props.maxLabel || props.maxValue}</p>
      </div>
    </div>
  )
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
    margin: '20px 0',
  },
  text: {
    color: COLORS.greyscale.black,
    fontSize: 14,
  },
  scoreRowContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    margin: '10px 0',
    width: 270,
    alignSelf: 'center',
  },
  badSection: {
    background: COLORS.uiSpecific.danger,
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    height: 28,
    width: 90,
  },
  midSection: {
    background: COLORS.uiSpecific.warning,
    height: 28,
    width: 90,
  },
  goodSection: {
    background: COLORS.uiSpecific.success,
    borderTopRightRadius: 12,
    borderBottomRightRadius: 12,
    height: 28,
    width: 90,
  },
  indicator: (props) => ({
    position: 'absolute',
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: `1px solid ${COLORS.greyscale.white}`,
    background: COLORS.brand.primaryDark,
    top: 2,
  }),
  minMaxRow: {
    display: 'flex',
    justifyContent: 'space-between',
    width: 270,
    alignSelf: 'center',
  },
})

export default ScoreRow
